import { FC } from 'react';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './TabHeader.module.scss';

type TabHeaderProps = {
  active: boolean;
  label: string;
  icon?: IconDefinition;
  className?: string;
};

const TabHeader: FC<TabHeaderProps> = ({ active, label, icon, className }) => (
  <div
    className={classNames(styles.tabHeader, active && styles.active, className)}
  >
    {icon && <FontAwesomeIcon icon={icon} />}
    {label}
  </div>
);

export default TabHeader;
